export default __webpack_public_path__ + "static/media/edital92024.90ffb5b4.pdf";